import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const VNIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="VN" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FFD221"
          fillRule="evenodd"
          d="M8.031 7.99 5.456 9.627l.863-2.866-1.837-1.873 2.533-.055 1.12-2.83L9.158 4.87l2.526.044-1.899 1.907.887 2.727-2.64-1.558Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
